import axios from 'axios'
import { backendUrl } from '../shared/API'

const token = localStorage.getItem('token')
const instance = axios.create({
  baseURL: backendUrl,
  headers: {
    Authorization: `Bearer ${token}`,
  },
})

export default instance
